'use strict';

var cov_2mvw5ku2y5 = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\main.js',
      hash = '3f4749e3fe08780ec776e51906c584415ba52c40',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\main.js',
    statementMap: {
      '0': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 30
        }
      },
      '1': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 7,
          column: 6
        }
      },
      '2': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 29
        }
      },
      '3': {
        start: {
          line: 9,
          column: 16
        },
        end: {
          line: 9,
          column: 49
        }
      },
      '4': {
        start: {
          line: 10,
          column: 18
        },
        end: {
          line: 10,
          column: 52
        }
      },
      '5': {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 85,
          column: 6
        }
      },
      '6': {
        start: {
          line: 83,
          column: 19
        },
        end: {
          line: 83,
          column: 23
        }
      },
      '7': {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 57
        }
      },
      '8': {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 109,
          column: 7
        }
      },
      '9': {
        start: {
          line: 87,
          column: 6
        },
        end: {
          line: 103,
          column: 11
        }
      },
      '10': {
        start: {
          line: 100,
          column: 10
        },
        end: {
          line: 100,
          column: 75
        }
      },
      '11': {
        start: {
          line: 102,
          column: 10
        },
        end: {
          line: 102,
          column: 54
        }
      },
      '12': {
        start: {
          line: 104,
          column: 6
        },
        end: {
          line: 108,
          column: 9
        }
      },
      '13': {
        start: {
          line: 105,
          column: 8
        },
        end: {
          line: 105,
          column: 48
        }
      },
      '14': {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 61
        }
      },
      '15': {
        start: {
          line: 111,
          column: 26
        },
        end: {
          line: 111,
          column: 87
        }
      },
      '16': {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 114,
          column: 32
        }
      },
      '17': {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 36
        }
      },
      '18': {
        start: {
          line: 116,
          column: 6
        },
        end: {
          line: 118,
          column: 8
        }
      },
      '19': {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 25
        }
      },
      '20': {
        start: {
          line: 119,
          column: 6
        },
        end: {
          line: 121,
          column: 8
        }
      },
      '21': {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 120,
          column: 27
        }
      },
      '22': {
        start: {
          line: 122,
          column: 6
        },
        end: {
          line: 163,
          column: 8
        }
      },
      '23': {
        start: {
          line: 123,
          column: 20
        },
        end: {
          line: 123,
          column: 53
        }
      },
      '24': {
        start: {
          line: 124,
          column: 19
        },
        end: {
          line: 124,
          column: 52
        }
      },
      '25': {
        start: {
          line: 125,
          column: 23
        },
        end: {
          line: 128,
          column: 9
        }
      },
      '26': {
        start: {
          line: 129,
          column: 23
        },
        end: {
          line: 132,
          column: 9
        }
      },
      '27': {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 162,
          column: 11
        }
      },
      '28': {
        start: {
          line: 134,
          column: 10
        },
        end: {
          line: 161,
          column: 11
        }
      },
      '29': {
        start: {
          line: 135,
          column: 12
        },
        end: {
          line: 135,
          column: 47
        }
      },
      '30': {
        start: {
          line: 136,
          column: 12
        },
        end: {
          line: 136,
          column: 29
        }
      },
      '31': {
        start: {
          line: 137,
          column: 12
        },
        end: {
          line: 137,
          column: 37
        }
      },
      '32': {
        start: {
          line: 138,
          column: 12
        },
        end: {
          line: 142,
          column: 15
        }
      },
      '33': {
        start: {
          line: 143,
          column: 12
        },
        end: {
          line: 143,
          column: 29
        }
      },
      '34': {
        start: {
          line: 144,
          column: 12
        },
        end: {
          line: 148,
          column: 13
        }
      },
      '35': {
        start: {
          line: 145,
          column: 14
        },
        end: {
          line: 145,
          column: 68
        }
      },
      '36': {
        start: {
          line: 146,
          column: 14
        },
        end: {
          line: 146,
          column: 55
        }
      },
      '37': {
        start: {
          line: 147,
          column: 14
        },
        end: {
          line: 147,
          column: 34
        }
      },
      '38': {
        start: {
          line: 150,
          column: 12
        },
        end: {
          line: 154,
          column: 15
        }
      },
      '39': {
        start: {
          line: 155,
          column: 12
        },
        end: {
          line: 160,
          column: 13
        }
      },
      '40': {
        start: {
          line: 156,
          column: 14
        },
        end: {
          line: 156,
          column: 31
        }
      },
      '41': {
        start: {
          line: 158,
          column: 14
        },
        end: {
          line: 158,
          column: 51
        }
      },
      '42': {
        start: {
          line: 159,
          column: 14
        },
        end: {
          line: 159,
          column: 31
        }
      },
      '43': {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 170,
          column: 6
        }
      },
      '44': {
        start: {
          line: 167,
          column: 6
        },
        end: {
          line: 169,
          column: 9
        }
      },
      '45': {
        start: {
          line: 168,
          column: 8
        },
        end: {
          line: 168,
          column: 48
        }
      },
      '46': {
        start: {
          line: 173,
          column: 0
        },
        end: {
          line: 178,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 3,
            column: 2
          },
          end: {
            line: 3,
            column: 3
          }
        },
        loc: {
          start: {
            line: 3,
            column: 154
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 3
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 19
          },
          end: {
            line: 5,
            column: 20
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 7,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 82,
            column: 23
          },
          end: {
            line: 82,
            column: 24
          }
        },
        loc: {
          start: {
            line: 82,
            column: 37
          },
          end: {
            line: 85,
            column: 5
          }
        },
        line: 82
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 86,
            column: 41
          },
          end: {
            line: 86,
            column: 42
          }
        },
        loc: {
          start: {
            line: 86,
            column: 58
          },
          end: {
            line: 109,
            column: 5
          }
        },
        line: 86
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 99,
            column: 14
          },
          end: {
            line: 99,
            column: 15
          }
        },
        loc: {
          start: {
            line: 99,
            column: 24
          },
          end: {
            line: 101,
            column: 9
          }
        },
        line: 99
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 101,
            column: 11
          },
          end: {
            line: 101,
            column: 12
          }
        },
        loc: {
          start: {
            line: 101,
            column: 17
          },
          end: {
            line: 103,
            column: 9
          }
        },
        line: 101
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 104,
            column: 20
          },
          end: {
            line: 104,
            column: 21
          }
        },
        loc: {
          start: {
            line: 104,
            column: 26
          },
          end: {
            line: 106,
            column: 7
          }
        },
        line: 104
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 106,
            column: 9
          },
          end: {
            line: 106,
            column: 10
          }
        },
        loc: {
          start: {
            line: 106,
            column: 28
          },
          end: {
            line: 108,
            column: 7
          }
        },
        line: 106
      },
      '8': {
        name: 'DialogController',
        decl: {
          start: {
            line: 113,
            column: 13
          },
          end: {
            line: 113,
            column: 29
          }
        },
        loc: {
          start: {
            line: 113,
            column: 64
          },
          end: {
            line: 164,
            column: 5
          }
        },
        line: 113
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 116,
            column: 20
          },
          end: {
            line: 116,
            column: 21
          }
        },
        loc: {
          start: {
            line: 116,
            column: 32
          },
          end: {
            line: 118,
            column: 7
          }
        },
        line: 116
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 23
          }
        },
        loc: {
          start: {
            line: 119,
            column: 34
          },
          end: {
            line: 121,
            column: 7
          }
        },
        line: 119
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 22
          }
        },
        loc: {
          start: {
            line: 122,
            column: 33
          },
          end: {
            line: 163,
            column: 7
          }
        },
        line: 122
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 133,
            column: 61
          },
          end: {
            line: 133,
            column: 62
          }
        },
        loc: {
          start: {
            line: 133,
            column: 71
          },
          end: {
            line: 162,
            column: 9
          }
        },
        line: 133
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 166,
            column: 20
          },
          end: {
            line: 166,
            column: 21
          }
        },
        loc: {
          start: {
            line: 166,
            column: 41
          },
          end: {
            line: 170,
            column: 5
          }
        },
        line: 166
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 167,
            column: 66
          },
          end: {
            line: 167,
            column: 67
          }
        },
        loc: {
          start: {
            line: 167,
            column: 77
          },
          end: {
            line: 169,
            column: 7
          }
        },
        line: 167
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 105,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 105,
            column: 29
          }
        }, {
          start: {
            line: 105,
            column: 33
          },
          end: {
            line: 105,
            column: 47
          }
        }],
        line: 105
      },
      '1': {
        loc: {
          start: {
            line: 111,
            column: 26
          },
          end: {
            line: 111,
            column: 87
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 111,
            column: 27
          },
          end: {
            line: 111,
            column: 41
          }
        }, {
          start: {
            line: 111,
            column: 45
          },
          end: {
            line: 111,
            column: 59
          }
        }, {
          start: {
            line: 111,
            column: 64
          },
          end: {
            line: 111,
            column: 87
          }
        }],
        line: 111
      },
      '2': {
        loc: {
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        }, {
          start: {
            line: 134,
            column: 10
          },
          end: {
            line: 161,
            column: 11
          }
        }],
        line: 134
      },
      '3': {
        loc: {
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 148,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 148,
            column: 13
          }
        }, {
          start: {
            line: 144,
            column: 12
          },
          end: {
            line: 148,
            column: 13
          }
        }],
        line: 144
      },
      '4': {
        loc: {
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 160,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 160,
            column: 13
          }
        }, {
          start: {
            line: 155,
            column: 12
          },
          end: {
            line: 160,
            column: 13
          }
        }],
        line: 155
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MainController =
/** @ngInject */
function MainController($scope, $window, $stateParams, $rootScope, $http, myVars, $httpParamSerializer, localStorageService, $state, $mdMedia, $mdDialog, ngNotify) {
  _classCallCheck(this, MainController);

  ++cov_2mvw5ku2y5.f[0];
  ++cov_2mvw5ku2y5.s[0];

  $scope.checkinfo = myVars;
  ++cov_2mvw5ku2y5.s[1];
  $scope.totop = function () {
    ++cov_2mvw5ku2y5.f[1];
    ++cov_2mvw5ku2y5.s[2];

    $window.scrollTo(0, 0);
  };

  var check = (++cov_2mvw5ku2y5.s[3], localStorageService.get('msisdn'));
  var islogin = (++cov_2mvw5ku2y5.s[4], localStorageService.get('islogin'));
  //
  // if ($stateParams.DATA === undefined || $stateParams.SIG === undefined) {
  //   $http.post($rootScope.apiOpen).then(results => {
  //     console.log(results.data.message);
  //     $window.location.href = results.data.message;
  //   });
  // } else {
  //   const dataSend = {
  //     dataVT: $stateParams.DATA,
  //     sigVT: $stateParams.SIG
  //   };
  //   $http({
  //     url: $rootScope.apiOpen + '/verify/',
  //     method: 'POST',
  //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  //     transformRequest: $httpParamSerializer, data: dataSend
  //   }).then(response => {
  //     // check msisdn
  //     if (response.data.status === '2' || response.data.status === null || response.data.status === '4') {
  //       // if (check !== null) {
  //       //   myVars.checkMember = '0';
  //       //   myVars.msisdn = check;
  //       // }
  //       // if (islogin !== true) {
  //         myVars.checkMember = response.data.status;
  //         myVars.msisdn = response.data.msisdn;
  //         myVars.packageid = response.data.packageid;
  //         localStorageService.set('msisdn', response.data.msisdn);
  //         localStorageService.set('islogin', false);
  //       // }
  //     }
  //
  //     // dang ky huy
  //     if (response.data.status === '0') {
  //       myVars.checkMember = response.data.status;
  //       myVars.msisdn = response.data.msisdn;
  //       myVars.packageid = response.data.packageid;
  //       localStorageService.set('msisdn', response.data.msisdn);
  //       localStorageService.set('islogin', true);
  //       islogin = localStorageService.get('islogin');
  //       myVars.login = islogin;
  //     }
  //
  //     if (response.data.status === '6') {
  //       $window.location.href = response.data.message;
  //     }
  //
  //
  //     if (response.data.status === '100') {
  //       myVars.checkMember = response.data.status;
  //       myVars.msisdn = response.data.msisdn;
  //       localStorageService.set('msisdn', response.data.msisdn);
  //       localStorageService.set('islogin', false);
  //       ngNotify.set('Hủy dịch vụ thành công', {
  //         position: 'top',
  //         type: 'success',
  //         duration: 10000
  //       });
  //       $http.post($rootScope.apiOpen).then(results => {
  //         console.log(results.data.message);
  //         $window.location.href = results.data.message;
  //       });
  //     }
  //     if (response.data.status === '303') {
  //       $window.location.href = response.data.message;
  //     }
  //   });
  //   islogin = localStorageService.get('islogin');
  //   myVars.login = islogin;
  // }

  ++cov_2mvw5ku2y5.s[5];
  $scope.showLogin = function (ev) {
    ++cov_2mvw5ku2y5.f[2];

    var data = (++cov_2mvw5ku2y5.s[6], true);
    ++cov_2mvw5ku2y5.s[7];
    $rootScope.$emit('CallMethodRegister', { ev: ev, data: data });
  };
  ++cov_2mvw5ku2y5.s[8];
  $rootScope.$on('CallMethodRegister', function (event, data) {
    ++cov_2mvw5ku2y5.f[3];
    ++cov_2mvw5ku2y5.s[9];

    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'app/dialog.html',
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: useFullScreen,
      locals: {
        types: data
      }
    }).then(function (answer) {
      ++cov_2mvw5ku2y5.f[4];
      ++cov_2mvw5ku2y5.s[10];

      $scope.status = 'You said the information was "' + answer + '".';
    }, function () {
      ++cov_2mvw5ku2y5.f[5];
      ++cov_2mvw5ku2y5.s[11];

      $scope.status = 'You cancelled the dialog.';
    });
    ++cov_2mvw5ku2y5.s[12];
    $scope.$watch(function () {
      ++cov_2mvw5ku2y5.f[6];
      ++cov_2mvw5ku2y5.s[13];

      return (++cov_2mvw5ku2y5.b[0][0], $mdMedia('xs')) || (++cov_2mvw5ku2y5.b[0][1], $mdMedia('sm'));
    }, function (wantsFullScreen) {
      ++cov_2mvw5ku2y5.f[7];
      ++cov_2mvw5ku2y5.s[14];

      $scope.customFullscreen = wantsFullScreen === true;
    });
  });

  var useFullScreen = (++cov_2mvw5ku2y5.s[15], ((++cov_2mvw5ku2y5.b[1][0], $mdMedia('sm')) || (++cov_2mvw5ku2y5.b[1][1], $mdMedia('xs'))) && (++cov_2mvw5ku2y5.b[1][2], $scope.customFullscreen));

  function DialogController($scope, $mdDialog, types, $state) {
    ++cov_2mvw5ku2y5.f[8];
    ++cov_2mvw5ku2y5.s[16];

    $scope.checkinfo = myVars;
    ++cov_2mvw5ku2y5.s[17];
    $scope.showClose = types.data;
    ++cov_2mvw5ku2y5.s[18];
    $scope.hide = function () {
      ++cov_2mvw5ku2y5.f[9];
      ++cov_2mvw5ku2y5.s[19];

      $mdDialog.hide();
    };
    ++cov_2mvw5ku2y5.s[20];
    $scope.cancel = function () {
      ++cov_2mvw5ku2y5.f[10];
      ++cov_2mvw5ku2y5.s[21];

      $mdDialog.cancel();
    };
    ++cov_2mvw5ku2y5.s[22];
    $scope.login = function () {
      ++cov_2mvw5ku2y5.f[11];

      var key = (++cov_2mvw5ku2y5.s[23], CryptoJS.lib.WordArray.random(16));
      var iv = (++cov_2mvw5ku2y5.s[24], CryptoJS.lib.WordArray.random(16));
      var member = (++cov_2mvw5ku2y5.s[25], {
        username: CryptoJS.AES.encrypt($scope.username, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString(),
        password: CryptoJS.AES.encrypt($scope.password, $rootScope.base64Key, { iv: $rootScope.iv }).ciphertext.toString()
      });
      var config = (++cov_2mvw5ku2y5.s[26], {
        params: member,
        headers: { Accept: 'application/json' }
      });
      ++cov_2mvw5ku2y5.s[27];
      $http.get($rootScope.apiOpen + 'login', config).then(function (result) {
        ++cov_2mvw5ku2y5.f[12];
        ++cov_2mvw5ku2y5.s[28];

        if (result.data.status === '0') {
          ++cov_2mvw5ku2y5.b[2][0];
          ++cov_2mvw5ku2y5.s[29];

          myVars.msisdn = result.data.msisdn;
          ++cov_2mvw5ku2y5.s[30];
          myVars.login = 1;
          ++cov_2mvw5ku2y5.s[31];
          myVars.checkMember = '0';
          ++cov_2mvw5ku2y5.s[32];
          ngNotify.set('Chào mừng ' + result.data.msisdn, {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          ++cov_2mvw5ku2y5.s[33];
          $mdDialog.hide();
          ++cov_2mvw5ku2y5.s[34];
          if (localStorageService.isSupported) {
            ++cov_2mvw5ku2y5.b[3][0];
            ++cov_2mvw5ku2y5.s[35];

            localStorageService.set('msisdn', result.data.msisdn);
            ++cov_2mvw5ku2y5.s[36];
            localStorageService.set('islogin', true);
            ++cov_2mvw5ku2y5.s[37];
            myVars.login = true;
          } else {
            ++cov_2mvw5ku2y5.b[3][1];
          }
        } else {
          ++cov_2mvw5ku2y5.b[2][1];
          ++cov_2mvw5ku2y5.s[38];

          ngNotify.set('Bạn chưa đăng ký dịch vụ hoặc mật khẩu không chính xác !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
          ++cov_2mvw5ku2y5.s[39];
          if (types === true) {
            ++cov_2mvw5ku2y5.b[4][0];
            ++cov_2mvw5ku2y5.s[40];

            $mdDialog.hide();
          } else {
            ++cov_2mvw5ku2y5.b[4][1];
            ++cov_2mvw5ku2y5.s[41];

            $state.go('app', {}, { reload: true });
            ++cov_2mvw5ku2y5.s[42];
            $mdDialog.hide();
          }
        }
      });
    };
  }

  ++cov_2mvw5ku2y5.s[43];
  $scope.dangky = function (packageid) {
    ++cov_2mvw5ku2y5.f[13];
    ++cov_2mvw5ku2y5.s[44];

    $http.post($rootScope.apiOpen + 'dangky/' + packageid).then(function (results) {
      ++cov_2mvw5ku2y5.f[14];
      ++cov_2mvw5ku2y5.s[45];

      $window.location = results.data.message;
    });
  };
};

++cov_2mvw5ku2y5.s[46];

angular.module('app').component('app', {
  templateUrl: 'app/main.html',
  controller: MainController
});